import { combineReducers } from "redux";
import home from "./home";
import character from "./character";

export default combineReducers({
  home,
  character
});
